import Workspace, { WorkspaceFolder } from "@/models/workspace/Workspace";

/**
 * Extracts metadata names and folder names separately from a workspace
 */
export const extractWorkspaceFiltersWithCategories = (
  workspace: Workspace
): { metadataNames: string[]; folders: { name: string; id: string }[] } => {
  const metadataNames = new Set<string>();
  const folders = new Map<string, { name: string; id: string }>(); // Use Map to avoid duplicates by ID

  const collect = (foldersList?: WorkspaceFolder[]) => {
    foldersList?.forEach(({ id, name, documents, folders: subFolders }) => {
      // Add folder to the map (this will handle duplicates by ID automatically)
      if (id && name) {
        folders.set(id, { name, id });
      }

      documents?.forEach(({ documentMetadataList }) =>
        documentMetadataList?.forEach(
          ({ name }) => name && metadataNames.add(name)
        )
      );

      collect(subFolders); // recurse
    });
  };

  workspace.documents?.forEach(({ documentMetadataList }) =>
    documentMetadataList?.forEach(({ name }) => name && metadataNames.add(name))
  );

  collect(workspace.folders);

  return {
    metadataNames: [...metadataNames].sort(),
    folders: Array.from(folders.values()).sort((a, b) =>
      a.name.localeCompare(b.name)
    ),
  };
};
